export function request(id, data) {
    id = parseInt(id, 10);

    return {
        type: 'CUSTOMERS_SAVE_HISTORY_REQUEST',
        id,
        data
    }
}
